import { Provider } from '@angular/core';
import { CustomerApiService, provideCustomerApiOrigin } from '@isaia/customer';
import { CustomerService } from './customer.service';
import { CustomerRepository } from './customer.repository';

export function provideCustomer(options: { origin: string }): Provider {
  return [provideCustomerApiOrigin(options.origin), CustomerApiService, CustomerService, CustomerRepository];
}
